/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';

import _ = require("lodash");
import { Draggable } from 'react-beautiful-dnd';
import { formFieldNames, IManagedExercise, IMicrocycleError } from "../../../../containers/FitnessPlan/FitnessTemplate/interface";
import AppUtils from "../../../../utils/AppUtils";
import TextInput from "../../../TextInput";
import { SearchableSelect } from "../../../common/SearchableSelect/SearchableSelect";
import { checkForError } from "../../../../containers/FitnessPlan/FitnessTemplate/helper";


interface IExerciseProps {
    exercise: any;
    handleExerciseChange: (updatedExercise: any) => void;
    exerciseList: any;
    handleDeleteExercise: () => void;
    exerciseIndex: number;
    outerIndex: number;
    errorStates: IMicrocycleError[];
    isViewMode: boolean;
}

export const Exercise: React.FC<IExerciseProps> = (props: IExerciseProps) => {
    const { exercise, handleExerciseChange, exerciseList, handleDeleteExercise, exerciseIndex, outerIndex, errorStates, isViewMode } = props;

    const handleExerciseSearch = (value: string, keyName: string) => {
        if (AppUtils.isDefined(value)) {
            let currentItem = { ...exercise, [keyName]: value };
            handleExerciseChange(currentItem);
        }
    }

    const handleExerciseDataChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let exerciseExecutions = exercise.executions && exercise.executions.map((execution: any) => {
            let currentExecution = { ...execution };
            if (event.target.name === formFieldNames.WEIGHT) {
                currentExecution[formFieldNames.WEIGHTUNIT] = "KG"
            }
            currentExecution[event.target.name] = event.target.value;
            return currentExecution;
        })

        let currentItem: IManagedExercise = { ...exercise, executions: exerciseExecutions }

        handleExerciseChange(currentItem);
    }

    const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let currentItem: IManagedExercise = { ...exercise, [event.target.name]: event.target.value };
        handleExerciseChange(currentItem);
    }

    const exerciseMetdata = _.get(exercise, "executions[0]", null);

    const currentExerciseErrors = errorStates && errorStates.filter(errorState => errorState.exerciseIndex === exerciseIndex)


    return (
        <div css={styles.exerciseContainer}>
            <Draggable
                key={`exercise_${exerciseIndex}_${outerIndex}`}
                draggableId={`exercise_${exerciseIndex}_${outerIndex}`}
                index={exerciseIndex}
                isDragDisabled={isViewMode}
            >
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        key={`exercise_key_${exerciseIndex}`}
                        style={provided.draggableProps.style}
                    >
                        {!isViewMode && <div css={styles.draggableIcon}>
                            <img src="/images/dragger.svg" alt="dragger" />
                        </div>}
                        <div css={styles.exerciseWrapper}>
                            <div className="exercise-title-wrapper">
                                {/* <CustomSelect dropdownValues={exerciseList} selectedValue={exerciseName} defaultValue="Enter Title" updateDropdownValue={handleExerciseSearch} keyName={formFieldNames.EXERCISEID} className={currentExerciseErrors && checkForError("EMPTY_EXERCISE") ? "exercise-title input-error" : "exercise-title"} /> */}
                                <SearchableSelect options={exerciseList} selectedValue={exercise.exerciseId} fieldName={formFieldNames.EXERCISEID} placeholder="Enter Title" onChange={handleExerciseSearch} hasError={checkForError(currentExerciseErrors, "EMPTY_EXERCISE")} isDisabled={isViewMode} />
                            </div>
                            <TextInput type="number" name={formFieldNames.COUNT} placeholder="Input Value" value={exerciseMetdata && exerciseMetdata.count} onChange={handleExerciseDataChange} customClasses={checkForError(currentExerciseErrors, "EITHER_OF_ONE_EXERCISE_SET_INFO") ? "exercise-meta input-error" : "exercise-meta"} disabled={isViewMode} />
                            <TextInput type="number" name={formFieldNames.DURATION} placeholder="Value in secs" value={exerciseMetdata && exerciseMetdata.duration} onChange={handleExerciseDataChange} customClasses={checkForError(currentExerciseErrors, "EITHER_OF_ONE_EXERCISE_SET_INFO") ? "exercise-meta input-error" : "exercise-meta"} disabled={isViewMode} />
                            <TextInput type="number" name={formFieldNames.WEIGHT} placeholder="Weight in kgs" value={exerciseMetdata && exerciseMetdata.weight} onChange={handleExerciseDataChange} customClasses="exercise-meta" disabled={isViewMode} />
                            <TextInput name={formFieldNames.COMMENTS} placeholder="Input Value" value={exercise.trainerComments} onChange={handleCommentChange} customClasses="exercise-comment" disabled={isViewMode} />
                            {!isViewMode && <img onClick={handleDeleteExercise} src="/images/icons/grey-cancel.png" css={styles.crossIconStyle} />}
                        </div>
                    </div>)}
            </Draggable>

        </div>

    )
}